import { render, staticRenderFns } from "./AttendLead.vue?vue&type=template&id=99fbab08&"
import script from "./AttendLead.vue?vue&type=script&lang=js&"
export * from "./AttendLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports